import { Id } from '@vimeo/core/types/generic';

import { EFirebasePersistenceType } from '../types/firebase';
import { EGraphicsDescriptorType } from '../types/graphics';

export const firebaseConfig = {
  AUTH: {
    DEFAULT_PERSISTENCE_TYPE: EFirebasePersistenceType.MEMORY,
  },
  /**
   * Schema paths definitions for ref pointing.
   */
  REFS: {
    INTERNAL: {
      CONNECTION_STATE: '.info/connected',
      SERVER_TIME_OFFSET: '.info/serverTimeOffset',
    },
    INTERACTION: {
      CHAT: {
        META(roomId: Id): string {
          return `/chats/${roomId}/meta`;
        },
        META_ENABLED(roomId: Id): string {
          return `${firebaseConfig.REFS.INTERACTION.CHAT.META(roomId)}/enabled`;
        },
        PUBLIC(roomId: Id): string {
          return `/chats/${roomId}/chat`;
        },
        GUEST(roomId: Id): string {
          return `/backstage/${roomId}/chat`;
        },
        PUBLIC_BANS(roomId: Id): string {
          return `/chats/${roomId}/users/bans`;
        },
      },
      POLLS: {
        ACTIVE(roomId: Id): string {
          return `/chats/${roomId}/meta/activePollId`;
        },
        LIST(roomId: Id): string {
          return `/polls/${roomId}/poll`;
        },
      },
      QNA: {
        SESSIONS(roomId: Id, sessionId: Id = ''): string {
          return `/qna/${roomId}/sessions${sessionId ? `/${sessionId}` : ''}`;
        },
        ACTIVE_ID(roomId: Id): string {
          return `/chats/${roomId}/meta/activeQnASessionId`;
        },
        MODERATION(roomHash: string): string {
          return `/settings/${roomHash}/isQnaModerated`;
        },
        ANONYMOUS_QUESTIONS(roomHash: string): string {
          return `/settings/${roomHash}/isAnonymousQuestionsDisabled`;
        },
        REPLIES_SESSIONS(roomId: Id): string {
          return `/qna_replies/${roomId}/sessions`;
        },
      },
    },
    STREAM_HEALTH: {
      APP_NAME(firestoreId: Id): string {
        return `live-event-${firestoreId}`;
      },
    },
    COMPOSER: {
      ACTIVE_BROADCASTER(sessionId: Id): string {
        return `/active_broadcaster/${sessionId}`;
      },
      PARTICIPANTS(sessionId: Id, participantId?: Id): string {
        return `/participants/${sessionId}${participantId ? `/${participantId}` : ''}`;
      },
      SCENE: {
        ACTIVE_SCENE(sessionId: Id): string {
          return `/active_scene/${sessionId}`;
        },
        SCENES(sessionId: Id): string {
          return `/scenes/${sessionId}`;
        },
        SCENE_ORDER(sessionId: Id): string {
          return `/scenes_order/${sessionId}`;
        },
      },
      GUESTS: {
        GUESTS(sessionId: Id): string {
          return `/guests/${sessionId}`;
        },
        GUEST_INVITES(sessionId: Id): string {
          return `/guest_invites/${sessionId}`;
        },
        GUEST_SETTINGS(sessionId: Id): string {
          return `/guest_settings/${sessionId}`;
        },
      },
      GRAPHICS: {
        ROOT(sessionId: Id): string {
          return `/graphics/${sessionId}`;
        },
        GRAPHICS(sessionId: Id, type: EGraphicsDescriptorType): string {
          return `/graphics/${sessionId}/${type}`;
        },
      },
      THEME(sessionId: Id): string {
        return `/theme/${sessionId}`;
      },
      SNAPSHOTS(sessionId: Id): string {
        return `/graphics_snapshots/${sessionId}`;
      },
      SETTINGS(sessionId: Id): string {
        return `/composer_settings/${sessionId}`;
      },
      /**
       * Studio debug info collection.
       */
      DEBUG: {
        DEBUG_INFO(sessionId: Id): string {
          return `/debug/${sessionId}`;
        },
      },
    },
  },
};
